<template>
  <v-dialog v-model="isShowForm" persistent width="600px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ this.$t('prop.modify') }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="closeForm()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="meta-form-pd">
        <v-text-field v-model="property.key" :label="$t('prop.key')" readonly outlined class="full-width-textarea"></v-text-field>
        <v-textarea v-model="property.value" :label="$t('prop.value')" auto-grow outlined class="full-width-textarea"></v-textarea>
        <v-textarea v-model="property.description" :label="$t('prop.desc')" readonly auto-grow outlined class="full-width-textarea"></v-textarea>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="closeForm()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
        <v-btn @click="confirmSave()" :disabled="!this.property.value" :loading="loading" small color="primary">{{ this.$t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from '@/api/common/instances';

export default {
  name: 'MetaForm',
  data() {
    return {
      loading: false,
      property: {},
      isShowForm: false,
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    async confirmSave() {
      this.closeForm();
      let confirmRslt = await this.$dialog.confirm(this.$t('prop.modify.confirm'));
      if (confirmRslt) this.save();
      else this.isShowForm = true;
    },
    closeForm() {
      this.isShowForm = false;
    },
    async save() {
      const param = new URLSearchParams();
      param.append('key', this.property.key);
      param.append('value', this.property.value);
      const { status } = await api.post('/prefer/prop/save-value', param);
      if (status == 200) this.$snackbar(this.$t('common.successful'));
      this.$emit('reRetrieve');
    },
  },
};
</script>
